import { render, staticRenderFns } from "./InvestorBankAccounts.vue?vue&type=template&id=1cbe2eea&scoped=true&"
import script from "./InvestorBankAccounts.vue?vue&type=script&lang=js&"
export * from "./InvestorBankAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbe2eea",
  null
  
)

export default component.exports